module.exports = __webpack_public_path__ + "viasat-fotboll-eafb8f364c896b1dcb74f12c913ba2cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/viasat-fotboll.jpg
// module id = 1155
// module chunks = 0 1